import React from 'react'
import { useTheme } from '@mui/material'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'

// Barra de falhas agrupadas por motivo. Enxerga só a página carregada — e o
// rótulo diz isso, porque um número que parece do período inteiro engana quem
// está decidindo se tem um problema pontual ou sistêmico.
export default function FailureDigest({ grupos, ativo, onSelecionar }) {
  const theme = useTheme()

  if (!grupos || grupos.length === 0) return null

  const total = grupos.reduce((soma, g) => soma + g.quantidade, 0)
  const corErro = theme.isDark ? '#ef5350' : '#c62828'

  return (
    <div
      className="mb-3 flex flex-wrap items-center gap-2 rounded px-3 py-2"
      style={{ backgroundColor: theme.isDark ? '#1c242e' : '#f7f8fa' }}
    >
      <span className="flex items-center gap-1.5 text-xs font-bold" style={{ color: corErro }}>
        <ReportProblemIcon style={{ fontSize: 15 }} />
        {total} {total === 1 ? 'falha nesta página' : 'falhas nesta página'}
      </span>

      {grupos.map((grupo) => {
        const selecionado = ativo === grupo.chave
        return (
          <button
            key={grupo.chave}
            type="button"
            aria-pressed={selecionado}
            onClick={() => onSelecionar(selecionado ? null : grupo.chave)}
            className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold"
            style={{
              backgroundColor: selecionado ? corErro : (theme.isDark ? '#161d25' : '#ffffff'),
              borderColor: selecionado ? corErro : (theme.isDark ? '#2b3641' : '#dfe3e8'),
              color: selecionado ? '#ffffff' : (theme.isDark ? '#aab6c2' : '#4a5661'),
            }}
          >
            <b style={{ color: selecionado ? '#ffffff' : (theme.isDark ? '#eef2f6' : '#111820') }}>
              {grupo.quantidade}
            </b>
            {grupo.titulo}
          </button>
        )
      })}
    </div>
  )
}
